// Wrapper fino sobre las Cloud Functions de perfil de usuario (Postgres/Neon).
import { getFunctions, httpsCallable } from 'firebase/functions';

const functions = getFunctions();
const obtenerMiPerfilFn = httpsCallable(functions, 'obtenerMiPerfil');
const actualizarMiPerfilFn = httpsCallable(functions, 'actualizarMiPerfil');
const actualizarUsuarioAdminFn = httpsCallable(functions, 'actualizarUsuarioAdmin');

export async function obtenerMiPerfil() {
  const result = await obtenerMiPerfilFn();
  return result.data.perfil;
}

export async function actualizarMiPerfil(empresa, telefono) {
  await actualizarMiPerfilFn({ empresa, telefono });
}

export async function actualizarUsuarioAdmin(datos) {
  await actualizarUsuarioAdminFn(datos);
}
